import { Outlet } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";

export default function Layout() {
  return (
    <div className="bg-white text-ink min-h-screen antialiased">
      <SmoothScroll />
      <ScrollToTop />
      <Nav />
      <main data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
